import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { placeholderMembersApi } from 'src/Services/API';
import { PlaceholderMemberDto } from 'src/Services/API/generated';
import { trackPlaceholderMemberFused } from 'src/Services/Mixpanel/events';
import { ApiError } from 'src/types/api-error.types';

interface ConvertVariables {
  placeholderId: string;
  targetUserId: string;
}

/**
 * A manager merges a non-registered co-owner into the account they turned out to be: their
 * shares, payments and fund call lines move to that account, and the duplicate line leaves
 * every balance.
 */
export const useConvertPlaceholderMember = () => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<PlaceholderMemberDto, AxiosError<ApiError>, ConvertVariables>({
    mutationFn: async ({ placeholderId, targetUserId }) =>
      (
        await placeholderMembersApi.placeholderMembersControllerConvert(placeholderId, {
          targetUserId,
        })
      ).data,
    onSuccess: (_data, { placeholderId }) => {
      trackPlaceholderMemberFused({
        asset_id: assetId ?? '',
        placeholder_id: placeholderId,
        trigger: 'manual_convert',
      });
      // The merge rewrites members, households, expenses, transfers, fund calls and every
      // balance of the asset: refetching everything is the honest invalidation here.
      queryClient.invalidateQueries();
    },
  });
};
